import { Container, Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  CustomTable,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  SearchTextInput,
  SelectInput,
  StatusChip,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { formatDate, getErrors } from "utils";
import { optionsNewsType } from "./Components/Contants";

function NewsAds() {
  const location = useLocation();
  const classes = globalStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const typeWeb = localStorage.getItem("typeWeb");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const urlParams = new URLSearchParams(location.search);
  const paramsSearch = urlParams.get("search") || "";
  const paramsPage = urlParams.get("page") || 1;
  const paramsSize = urlParams.get("size") || 10;
  const paramsType = urlParams.get("type") || "";
  const paramsStatus = urlParams.get("is_approved") || "";
  const paramsSort = urlParams.get("sort") || "-created_at";
  const isMpis = typeWeb === "mpis";

  const [loadingPage, setLoadingPage] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: Number(paramsPage) || 1,
    size: Number(paramsSize) || 10,
    search: paramsSearch || "",
    type: paramsType || "",
    ...(isMpis
      ? { sort: paramsSort || "-created_at" }
      : { status: paramsStatus || "" }),
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const handleChangePageParams = (value, key) => {
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    handleChangePageParams(value, key);
    if (key !== "page") {
      handleChangePageParams(1, "page");
    }
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/article${isMpis ? "/pending" : ""}`,
        {
          headers,
          params: queryParams,
        }
      );

      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  const handleDelete = async item => {
    try {
      setLoadingPage(true);
      await axios.delete(`${hardBaseUrl}/article/${item?.article_id}`, {
        headers,
      });
      ModalSuccess("Data Deleted Successfully").then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    debounceDataTable();
    if (queryParams?.page !== paramsPage) {
      handleChangePageParams(queryParams?.page, "page");
    }
    return () => {
      debounceDataTable.cancel();
    };
  }, [queryParams, debounceDataTable]);

  return (
    <Page className={classes.root} title="News & Ads">
      <Container maxWidth={false}>
        <HeaderTitle title="News & Ads" breadcrumbData={breadcrumbData} />
        <Divider className={classes.divider} />
        <Grid container justifyContent="space-between" mb="16px">
          <Grid item>
            <SearchTextInput
              placeholder="Search"
              value={queryParams?.search}
              onChange={e =>
                handleChangeQueryParams(e?.target?.value, "search")
              }
              disabled={loadingPage}
            />
          </Grid>
          <Grid item>
            <Grid container columnSpacing={1} alignItems="center">
              <Grid item>
                <SelectInput
                  label="Type"
                  options={optionsNewsType}
                  optionKey="key"
                  optionLabel="label"
                  value={queryParams?.type || ""}
                  onChange={e =>
                    handleChangeQueryParams(e?.target?.value, "type")
                  }
                  placeholder="All Type"
                  width={200}
                  disabled={loadingPage}
                />
              </Grid>
              {isMpis ? (
                <Grid item>
                  <SelectInput
                    options={optionSort}
                    optionKey="key"
                    optionLabel="label"
                    value={queryParams?.sort}
                    onChange={e =>
                      handleChangeQueryParams(e?.target?.value, "sort")
                    }
                    width={200}
                    disabled={loadingPage}
                  />
                </Grid>
              ) : (
                <Fragment>
                  <Grid item>
                    <SelectInput
                      label="Status"
                      options={optionStatus}
                      optionKey="key"
                      optionLabel="label"
                      value={queryParams?.status}
                      onChange={e =>
                        handleChangeQueryParams(e?.target?.value, "status")
                      }
                      placeholder="All Status"
                      width={200}
                      disabled={loadingPage}
                    />
                  </Grid>
                  <Grid item>
                    <PrimaryButton
                      label="Create News/ Ads"
                      startIcon={<Add />}
                      onClick={() =>
                        history.push("/admin/berita-publisher/tambah")
                      }
                      size="large"
                      disabled={loadingPage}
                    />
                  </Grid>
                </Fragment>
              )}
            </Grid>
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable({ isMpis })}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "size")
          }
          isHaveAction
          deleteConfirmation
          deleteConfirmationKey="title"
          disabledDelete={isMpis}
          handleDelete={item => handleDelete(item)}
          disabledEdit={item =>
            item?.status === "disetujui" || item?.status === "ditolak"
          }
          handleEdit={item =>
            history.push(
              `/admin/${
                isMpis ? "finalisasi-berita/view" : "berita-publisher/edit"
              }/${item?.article_id}`
            )
          }
          handleView={item =>
            history.push(`/admin/berita-publisher/${item?.article_id}`)
          }
        />
      </Container>
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "News & Ads",
    active: true,
  },
];
const optionStatus = [
  {
    key: "rejected",
    label: "Rejected",
  },
  {
    key: "approved",
    label: "Approved",
  },
  {
    key: "in_submission",
    label: "In Submission",
  },
];
const optionSort = [
  {
    key: "-created_at",
    label: "Latest",
  },
  {
    key: "created_at",
    label: "Oldest",
  },
];
const columnTable = ({ isMpis }) => [
  {
    name: "title",
    title: "Title",
  },
  {
    name: "type",
    title: "Type",
    renderText: item =>
      optionsNewsType?.find(status => status?.key === item)?.label,
  },
  ...(isMpis
    ? [
        {
          name: "publisher",
          title: "Publisher",
          renderText: item => item?.name || "-",
        },
      ]
    : [
        {
          name: "status",
          title: "Status",
          renderText: item => {
            const approved = item === "disetujui";
            const rejected = item === "ditolak";
            return (
              <StatusChip
                type={approved ? "success" : rejected ? "danger" : ""}
                label={
                  approved
                    ? "Approved"
                    : rejected
                    ? "Rejected"
                    : "In Submission"
                }
              />
            );
          },
        },
      ]),
  {
    name: "date",
    title: "Date",
    renderText: item => formatDate(item),
  },
];

export default NewsAds;
